import './echarts-register';
import 'vue-echarts/style.css';
import { createMesFeApp } from '@axsolutionsdev/mes-fe/bootstrap';
import { egmBranding } from './branding';

/**
 * Tier 3 EGM SaaS — Tier 2 `@axsolutionsdev/mes-fe` 와 동일 MES 화면·라우트를 계승하고,
 * 브랜딩만 EGM 표기로 구분한다.
 */
createMesFeApp({
  branding: egmBranding,
  /** 시드 부트스트랩 테넌트 코드 — UI 기본값 (SaaS 로그인 폼 그대로 노출 시 참고) */
  defaultLoginTenantCode: 'egm-platform',
  /** EGM 김치공장 시드 — ProcessType K_WASH/K_BRINE/K_METAL/K_PACK */
  processDataStatusProfile: 'kimchi',
}).app.mount('#app');
